module.exports = __webpack_public_path__ + "media/images/menu/sport-8bea9fa8e6a9880b2848268a122b6175.svg";